<template>
  <!-- 是否支持多选
       @author: 王汝鹏
       @date: 2019-9-10
   -->
  <div class="setting-item">
    <el-form-item label="是否多选"> 
      <el-radio-group v-model="multiple" size="small">
        <el-radio-button :label="false">否</el-radio-button>
        <el-radio-button :label="true">是</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 是否多选
     *  @description 将 multiple 字段映射到当前 multiple 计算属性
     *  @return {Boolean}
     *  @author 王汝鹏
     *  @version 2019-09-15
     */
    ...mapComputed({
      multiple: { 
        parent: i => i.baseOption,
        attr: "multiple",
      }
    }),
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingSelectMultiple.vue